<template>
  <td class="govuk-table__cell">
    <slot />
  </td>
</template>